import RestService from "~/core/services/rest.service";
import businessUnitService from "~/modules/businessUnit/services/businessUnit.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";

class UserProfileBusinessUnitService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    businessUnitCode,
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfile[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(
      `${businessUnitService.getBusinessUnitPath(businessUnitCode)}/profiles`,
      {
        params,
      },
    );
  }
}

export default new UserProfileBusinessUnitService();
